import React from 'react';
import {View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import AddToWallet from '../../components/rewards/AddToWallet';
import InStoreCode from '../../components/rewards/InStoreCode';
import MemberCard from '../../components/rewards/MemberCard';
import Button from '../../components/themed/Button';
import Text from '../../components/themed/Text';
import ContentView from '../../components/ui-controls/layout/ContentView';
import config from '../../config';
import logoImg from '../../images/brand/header-logo.png';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';
import {rewardsMarketingName} from '../../utils/rewards';

const RewardsSuccess = observer(
  ({
    route,
    navigation,
  }: RouteNavigatorScreenProps<
    AppRoute.REWARDS_SUCCESS | AppRoute.REWARDS_ACTIVATE_SUCCESS
  >) => {
    const {rewardsStore, userStore} = useStores();

    const flow = route?.params?.flow;

    const cardNumber = rewardsStore.cardNumber || '';
    const firstName = userStore.firstName || rewardsStore.firstName;
    const memberName =
      userStore.name || `${rewardsStore.firstName} ${rewardsStore.lastName}`;
    const code = rewardsStore.shortcode || '';
    const walletUrl = rewardsStore.walletUrl || '';

    return (
      <KeyboardAwareScrollView
        style={{backgroundColor: 'white'}}
        keyboardShouldPersistTaps="always">
        <ContentView>
          <Text variant="heading1">
            HERE’S YOUR {rewardsMarketingName.toUpperCase()} CARD
          </Text>

          <Text variant="body2">
            Nice one, {firstName}! You are now a part of our
            {` ${rewardsMarketingName} `}
            program! Show this barcode at checkout to collect awesome rewards!
          </Text>
          <View style={{gap: 8, marginTop: 24}}>
            <MemberCard
              logoImg={logoImg}
              cardNumber={cardNumber}
              name={memberName}
            />
            <AddToWallet walletUrl={walletUrl} />
          </View>

          <Text style={{fontWeight: 600, marginTop: 50}} variant="heading2">
            Your temporary rewards code
          </Text>
          <Text variant="body2" style={{marginTop: 8}}>
            Want to keep ahold of your phone? Give this code at checkout
            instead.
          </Text>

          <InStoreCode inStoreCode={code} />

          {flow !== 'activate' && (
            <>
              <Text style={{fontWeight: 600, marginTop: 40}} variant="body2">
                Check your email
              </Text>
              <Text variant="body2" style={{marginTop: 16}}>
                Although your account is ready to go, we have sent you an email
                to complete the last few steps and give you access to our
                website to see all of your member benefits.
              </Text>
            </>
          )}

          <View style={{gap: 8, marginTop: 40}}>
            <Button
              secondary
              title={`GO TO ${_.toUpper(config.APP_NAME)} HOME`}
              onPress={() => {
                navigation.navigate(AppRoute.ROOT, {
                  screen: AppRoute.MAIN,
                  params: {screen: AppRoute.HOME},
                });
              }}
            />
          </View>
        </ContentView>
      </KeyboardAwareScrollView>
    );
  },
);

export default RewardsSuccess;
